import axios from 'axios';
import { Filter } from '@uni-space/uni-components';
import { sort_center_api } from '@shared/api';
import { FetchCtx } from '@shared/types/api';
import { PageList } from '@shared/types/filter';
import { ManualWeight, ParcelDto } from '@shared/types/parcel';
import { WeightUnit } from '@shared/types/weight';
import { makeQueryString } from '@shared/utils/pagging';
import { CheckParcelWeightResponse, WeightCheckBagDto } from '../model/weightCheck';

// Все мешки сортировочного центра (партнёра оператора), а не только созданные им
export async function getSortCenterBags(
  page: number | undefined,
  pageSize: number | undefined,
  filters: Filter[] | undefined,
  ctx?: FetchCtx,
): Promise<PageList<WeightCheckBagDto>> {
  const nextFilters: Filter[] = [...(filters ?? []), { name: 'showAll', value: 'true' }];
  const url = `v1/bags?` + makeQueryString(page, pageSize, nextFilters);
  const result = await sort_center_api<PageList<WeightCheckBagDto>>(url, { signal: ctx?.signal });
  return result.data;
}

export async function getBagParcels(bagId: number): Promise<ParcelDto[]> {
  const result = await sort_center_api<{ items: ParcelDto[] }>(`v1/parcels/${bagId}/bag`);
  return result.data.items;
}

export async function checkParcelWeight(bagId: number, trackNumber: string, weightGrams: number) {
  const result = await sort_center_api.post<CheckParcelWeightResponse>('v1/parcels/check-weight', {
    bagId,
    trackNumber,
    weight: { value: weightGrams, unit: WeightUnit.g },
  });
  return result.data;
}

// Локальный сервис весов на рабочем месте оператора; вес приходит в граммах.
// Запрос идёт «голым» axios: интерцепторы sort_center_api добавляют Authorization,
// который не покрывается Access-Control-Allow-Headers: * и валит CORS preflight.
export async function getScalesWeight(signal?: AbortSignal): Promise<ManualWeight | null> {
  try {
    const res = await axios.get<ManualWeight>('http://localhost:7887/', { signal });
    return res.data ?? null;
  } catch {
    return null;
  }
}
